import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IPartnerResourceContext } from 'src/app/xena-api/dtos';
import { IListOptionsFilter, IQueryStringFilter } from 'src/app/xena-api/filters';
import { Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class PartnerResourceService extends BaseService<IPartnerResourceContext, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'Resource');
  }

  getForScheduling(filter: IPartnerResourceContextGetForFilter): Observable<Page<IPartnerResourceContext>> {
    return this.xenaClient.list(`${this.buildUrl()}/Scheduling`, filter);
  }

  getForFinance(filter: IPartnerResourceContextGetForFilter): Observable<Page<IPartnerResourceContext>> {
    return this.xenaClient.list(`${this.buildUrl()}/Finance`, filter);
  }
}

export interface IPartnerResourceContextGetForFilter extends IQueryStringFilter {
  showFormerEmployees?: boolean;
}
